import { injectable, inject } from 'inversify';
import { CommandHandler } from '@/app/tracking/api';
import { ErrorHandlingScorm2004Client, ErrorHandlingScorm2004ClientSymbol } from '@/app/tracking/scorm/2004/client';
import { CloseCourseCommand } from '../api';

@injectable()
export class Scorm2004CloseCourseCommandHandler implements CommandHandler<CloseCourseCommand> {

  constructor(
    @inject(ErrorHandlingScorm2004ClientSymbol)
    private readonly client: ErrorHandlingScorm2004Client) {
  }

  public async execute() {
    this.client.commit();
    this.client.terminate();
  }
}
